$(document).on('click', '.print-btn', () => $.print('#printTerms'))

$(document).on('click', '.checkout-print-btn', () => $.print('.elements-confirmation-page'))
